import React, { useEffect, useState, ChangeEvent } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  FormGroup,
  FormControl,
  Button,
  TextField,
  Typography,
} from '@mui/material';
import userProfile from '../../../../assets/images/userProfile.svg';
import profileDelete from '../../../../assets/images/profileDeleteIcon.svg';
import { PasswordInput } from '../../../../components/TextFields';
import { useAlert } from '../../../../components/Notification';
import createAxiosInstance from '../../../../api';
import { hashPassword } from '../../../../constant/constant';
import Popup from '../../../../components/Popup';
import CropComponent from '../../../../components/crop';
import { useForm } from 'react-hook-form';
import { useHook as DealerManagementHook } from './useHook';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
interface roles {
  roleName: string;
  roleID: string;
}
interface Props {
  pagePermissionIDs: unknown;
}

type ImageString = string;
type SetImageString = React.Dispatch<React.SetStateAction<ImageString>>;

const CreateRole: React.FC<Props> = ({ pagePermissionIDs }) => {
  const axiosInstance = createAxiosInstance();
  const { fetchDealerDetails, handleDeleteDealer, updateDealerPassword } =
    DealerManagementHook();
  const showAlert = useAlert();
  const location = useLocation();
  const { id: paramid } = useParams();
  const [roles, setrole] = useState<roles[]>([]);
  const [editDetails, setEditData]: any = useState({});
  const navigate = useNavigate();
  const editData = location.state && location.state.user;
  const [countryCode, setCountryCode] = useState('+91');
  const [mobileNumberError, setMobileNumberError] = useState('');
  const [userEmailError, setUserEmailError] = useState('');
  const [userPasswordError, setuserPasswordError] = useState('');
  const [roleError, setRoleError] = useState('');
  const [profileError, setProfileError] = useState('');
  const [imageString, setImageString]: [ImageString, SetImageString] =
    useState('');
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteid, setDeleteid] = useState<string>('');
  const [dialogText, setDialogText] = useState('');
  const [assignRole, setAssignRole] = useState<string[]>([]);
  const [password, setPassword] = useState('');
  const [isPasswordValid, setisPasswordValid] = useState(false);
  const [opencrop, setOpenCrop] = useState(false);
  const [filteredRole, setFilteredRole] = useState<roles[]>([]);
  const [roleSearch, setRoleSearch] = useState('');
  const [uploadError, setUploadError] = useState('');

  // const canupdatePasswordUsers =
  //   Array.isArray(pagePermissionIDs) &&
  //   pagePermissionIDs.includes('dealers::updatePassword');
  // const canchangeUserStatususers =
  //   Array.isArray(pagePermissionIDs) &&
  //   pagePermissionIDs.includes('dealers::changeUserStatus');
  const canupdatedealer =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dealers::update');
  const canGetDealer =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dealers::get');

  // const canRolelistPermission =
  //   Array.isArray(pagePermissionIDs) &&
  //   pagePermissionIDs.includes('roles::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['dealers::get'] || ''}</li>
        {/* <li>{ErrorMessage['roles::list'] || ''}</li> */}
      </ul>
    </section>
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm();

  const fetchImage = async (imageUrl: RequestInfo | URL) => {
    if (imageUrl) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const base64String = reader.result.toString().split(',')[1]; // Extracting base64 string
            const imageString = `data:image/png;base64,${base64String}`;
            setCroppedImages(imageString); // Set the base64 string to state
          }
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error('Failed to fetch image:', error);
      }
    }
  };

  const getoneUserDetails = async (id: string) => {
    await fetchDealerDetails({ dealerId: id }).then((res: any) => {
      fetchImage(res?.avatar);
      setValue('firstName', res?.firstName || '');
      setValue('lastName', res?.lastName || '');
      setValue('phoneNumber', res?.phoneNumber || '');
      setValue('email', res?.primaryEmail || '');
      setValue('orgName', res?.orgName || '');
      // setValue('role', res?.roles || []);
      // setImageString(res?.avatar);
      setCountryCode('+91');
      setAssignRole(res?.roles ? res?.roles : []);
    });
  };

  useEffect(() => {
    if (paramid && canGetDealer) {
      getoneUserDetails(paramid);
    }
  }, [paramid, canGetDealer]);

  const [croppedImage, setCroppedImages] = useState<string | null>(null);

  const handleCropComplete = (croppedImage: string) => {
    setCroppedImages(croppedImage);
    setOpenCrop(false);
    setUploadError('');
  };

  const validation = (validate?: string, formData?: any) => {
    let valid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (validate == 'password') {
      if (password?.length < 7) {
        setuserPasswordError('Password must be at least 8 characters long.');
        valid = false;
      }
    } else {
      if (!emailRegex.test(formData?.email)) {
        setUserEmailError('Invalid email address');
        valid = false;
      }

      if (opencrop) {
        setUploadError('Please upload the image');
        valid = false;
      }
      // if (!phoneRegex.test(formData?.phoneNumber)) {
      //   setMobileNumberError('Invalid mobile number');
      //   valid = false;
      // }

      // if (password?.length > 0) {
      //   setuserPasswordError('Update your password');
      //   valid = false;
      // }

      // if (countryCode?.length <= 0 && formData?.phoneNumber?.length > 0) {
      //   setMobileNumberError('Country code is required');
      //   valid = false;
      // }
      // if (formData?.role?.length <= 0) {
      //   setRoleError('Role is required');
      //   valid = false;
      // }
    }

    return valid;
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    event.preventDefault(); // Prevents submission
    updateUserPassword(password);
  };
  const handlesubmit = (userData: any) => {
    if (validation('', userData)) {
      const imageType = croppedImage?.substring(11, croppedImage?.indexOf(';'));
      const imageWithoutPrefix = croppedImage?.substring(
        croppedImage?.indexOf(',') + 1,
      );
      const createpayload = {
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        email: userData?.email,
        roles: userData?.role,
        // phoneNumber: userData?.phoneNumber,
        avatar: imageWithoutPrefix,
        ext: imageType,
      };

      const userid = paramid;

      const updatepayload = {
        dealerID: userid,
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        roles: userData?.role,
        phoneNumber: userData?.phoneNumber,
        orgName: userData?.orgName,
        avatar: imageWithoutPrefix,
        ext: imageType,
      };

      const url = userid ? '/updateDealer' : '/createDealer';
      const payload = userid ? updatepayload : createpayload;

      axiosInstance
        .post(url, payload)
        .then(() => {
          showAlert(
            `Dealer ${userid ? 'Update' : 'Created'} successfully`,
            'success',
          );
          navigate('/iam/dealermanagement');
        })
        .catch(() => {
          showAlert(
            `Failed to ${userid ? 'Update' : 'Created'} Dealer`,
            'error',
          );
        });
    }
  };

  //delete dealer
  const handleDelete = async () => {
    await handleDeleteDealer({ dealerID: paramid });
    setDeletePopup(false);
    navigate('/iam/dealermanagement');
  };

  const validateImage = (
    file: File,
    setProfileError: (error: string) => void,
  ): boolean => {
    const allowedTypes: string[] = ['image/jpeg', 'image/png', 'image/gif'];
    const maxFileSize: number = 1024 * 1024; // 1MB

    if (!allowedTypes.includes(file.type)) {
      setProfileError('Please select a JPG, GIF, or PNG file.');
      return false;
    }

    if (file.size > maxFileSize) {
      setProfileError('File size exceeds the 1MB limit.');
      return false;
    }

    return true;
  };

  const handleFileButtonClick = () => {
    const fileInput = document.getElementById(
      'upload-button',
    ) as HTMLInputElement;

    if (fileInput) {
      fileInput.click();
    }
  };

  const toBase64 = (file: Blob) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Failed to read file as Data URL'));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file: File | null = e.target.files ? e.target.files[0] : null;

    if (file && validateImage(file, setProfileError)) {
      setProfileError('');

      await toBase64(file)
        .then((base64String) => {
          setImageString(base64String as string);
          setCroppedImages(base64String as string);
          setOpenCrop(true);
        })
        .catch(() => {
          setImageString('');
          setCroppedImages('');
          showAlert(`Failed to Upload Image.`, 'error');
          setOpenCrop(false);
        });
    }
  };

  const handleDeleteImage = () => {
    setImageString('');
    setCroppedImages('');
    setUploadError('');
    const uploadInput = document.getElementById(
      'upload-button',
    ) as HTMLInputElement;
    if (uploadInput) {
      uploadInput.value = '';
    }
  };

  const changeUserStatus = (type: string) => {
    axiosInstance
      .post('/changeDealerStatus', {
        dealerID: paramid,
        status: type == 'activate' ? 'active' : type,
      })
      .then(() => {
        navigate('/iam/dealermanagement');
        showAlert(
          `Dealer ${type == 'suspend' ? 'Suspend' : 'Delete'} successfully`,
          'success',
        );
      })
      .catch(() => {
        showAlert(
          `Failed to ${type == 'suspend' ? 'Suspend' : 'Delete'} Dealer`,
          'error',
        );
      });
  };

  const updateUserPassword = async (password: string) => {
    if (validation('password')) {
      const payload = {
        dealerID: paramid,
        password: hashPassword(password),
      };
      await updateDealerPassword(payload);
      setPassword('');
    }
  };

  return (
    <>
      {!canGetDealer && paramid ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          {deletePopup && (
            <Popup
              open={deletePopup}
              btntext={deleteid}
              dialogText={dialogText}
              handleClose={() => {
                setDeletePopup(false);
              }}
              // handleDelete={handleDelete}
              handleDelete={() => {
                changeUserStatus(deleteid);
              }}
              page="Dealer"
            />
          )}
          <div className="create_user_management">
            <form onSubmit={handleSubmit(handlesubmit)}>
              <FormControl className="w-100">
                <div className="row d-flex  w-100">
                  <div className="col-md-6">
                    <Typography variant="h6">
                      <b>Name</b>
                    </Typography>
                    <Typography
                      variant="body2"
                      className="create_user_formlabel"
                    >
                      Provide first name and last name of new dealer
                    </Typography>
                  </div>
                  <div className="col-md-6  p-0 ">
                    <FormGroup>
                      <div className="create_user_name">
                        <TextField
                          className="create_user_name_input"
                          id="firstName"
                          variant="outlined"
                          {...register('firstName', { required: true })}
                          onChange={() => clearErrors('firstName')}
                          error={errors.firstName ? true : false}
                          placeholder="First Name"
                        />
                        <TextField
                          className="create_user_name_input"
                          id="lastName"
                          {...register('lastName', { required: true })}
                          onChange={() => clearErrors('lastName')}
                          error={errors.lastName ? true : false}
                          variant="outlined"
                          placeholder="Last Name"
                        />
                      </div>
                    </FormGroup>
                    {(errors.firstName || errors.lastName) && (
                      <span className="text-danger">
                        {'Dealer name is required'}
                      </span>
                    )}
                  </div>
                </div>
                <hr />
                <div className="row d-flex  w-100">
                  <div className="col-md-6">
                    <h6 className="m-0">
                      <b>Profile Picture</b>
                    </h6>
                  </div>
                  <div className="col-md-6 p-0">
                    <div className="create_user_profile-container">
                      <div className="create_user_profile">
                        <div>
                          {croppedImage ? (
                            <img
                              src={croppedImage}
                              width={72}
                              alt="User Profile"
                            />
                          ) : (
                            <img
                              src={userProfile}
                              width={72}
                              alt="User Profile"
                            />
                          )}
                        </div>
                        <div>
                          <label
                            // variant="outlined"
                            // component="label"
                            htmlFor="upload-button"
                            className="custom-file-upload"
                          >
                            Change
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            id="upload-button"
                            onChange={(e) => handleFileChange(e)}
                          />
                        </div>
                        <div className="imageformat">
                          <p>JPG, GIF, or PNG. 1MB Max.</p>
                        </div>
                      </div>
                      {croppedImage && (
                        <Button
                          className="create_user_profile-delete"
                          onClick={() => handleDeleteImage()}
                        >
                          <img
                            src={profileDelete}
                            width={44}
                            alt="delete icon"
                          />
                        </Button>
                      )}
                    </div>
                    {profileError && (
                      <span className="text-danger">{profileError}</span>
                    )}
                    {opencrop && croppedImage && (
                      <CropComponent
                        srce={croppedImage}
                        onCropComplete={handleCropComplete}
                        uploadError={uploadError}
                      />
                    )}
                  </div>
                </div>
                <hr />
                {/* <div className="row d-flex  w-100">
                  <div className="col-md-6">
                    <h6 className="m-0">
                      <b>Contact Number</b>
                    </h6>
                    <p className="m-0 create_user_formlabel">
                      Provide contact number
                    </p>
                  </div>
                  <div className="col-md-6  p-0 ">
                    <FormGroup>
                      <div className="create_user_name">
                        <Select
                          className="form-countrycode"
                          id="countrycode"
                          value={'+91'}
                          onChange={(e) => {
                            setCountryCode('+91'), setMobileNumberError('');
                          }}
                          error={
                            mobileNumberError || errors.phoneNumber
                              ? true
                              : false
                          }
                          variant="outlined"
                        >
                          <MenuItem value="+91">+91</MenuItem>
                        </Select>
                        <TextField
                          className="form-mobile"
                          id="phoneNumber"
                          placeholder="Phone number"
                          {...register('phoneNumber', { required: true })}
                          inputProps={{ maxLength: 10 }}
                          onChange={(e) => {
                            const sanitizedValue = e.target.value.replace(
                              /\D/g,
                              '',
                            );
                            if (sanitizedValue.length <= 10) {
                              setValue('phoneNumber', sanitizedValue);
                              clearErrors('phoneNumber');
                            }
                            setMobileNumberError('');
                          }}
                          variant="outlined"
                          error={
                            mobileNumberError || errors.phoneNumber
                              ? true
                              : false
                          }
                        />
                      </div>
                    </FormGroup>
                    {mobileNumberError && (
                      <span className="text-danger">{mobileNumberError}</span>
                    )}
                    {errors.phoneNumber && (
                      <span className="text-danger">
                        {'Mobile number is required'}
                      </span>
                    )}
                  </div>
                </div>
                <hr /> */}
                <div className="row d-flex  w-100">
                  <div className="col-md-6">
                    <h6 className="m-0">
                      <b>Email Address</b>
                    </h6>
                    <p className="m-0 create_user_formlabel">
                      This is the email address using which dealer will log in
                    </p>
                  </div>
                  <div className="col-md-6  p-0 ">
                    <FormGroup>
                      <TextField
                        disabled={editData?.userID ? true : false}
                        id="email"
                        {...register('email', { required: true })}
                        error={userEmailError || errors.email ? true : false}
                        placeholder="Email Address"
                        onChange={() => {
                          clearErrors('email');
                          setUserEmailError('');
                        }}
                        variant="outlined"
                        fullWidth
                      />
                    </FormGroup>
                    {userEmailError && (
                      <span className="text-danger">{userEmailError}</span>
                    )}
                    {errors.email && (
                      <span className="text-danger">{'Email is required'}</span>
                    )}
                  </div>
                </div>
              </FormControl>
              <hr />

              {paramid ? (
                <>
                  {/* {canupdatePasswordUsers && (
                    <> */}
                  <div className="row d-flex  w-100">
                    <div className="col-md-6">
                      <h6 className="m-0">
                        <b>Update Password</b>
                      </h6>
                      <p className="m-0 create_user_formlabel">
                        Override password for the user
                      </p>
                    </div>
                    <div className="col-md-6  p-0 ">
                      <FormGroup>
                        <div className="create_user_name">
                          <div className="col-md-8  p-0 ">
                            <FormGroup>
                              <PasswordInput
                                label={null}
                                errorshow={false}
                                value={password}
                                handleValid={setisPasswordValid}
                                onChange={setPassword}
                                error={isPasswordValid}
                                onKeyDown={handleKeyDown}
                              />
                            </FormGroup>
                          </div>
                          <div className="update_password-btn d-flex justify-content-end">
                            <Button
                              color="primary"
                              onClick={() => updateUserPassword(password)}
                            >
                              Update Password
                            </Button>
                          </div>
                        </div>
                        {!isPasswordValid && (
                          <span className="text-danger">
                            {userPasswordError}
                          </span>
                        )}
                      </FormGroup>
                    </div>
                  </div>
                  <hr />
                  {/* </>
                  )} */}
                  {/* {canchangeUserStatususers && (
                    <> */}
                  <div className="row d-flex  w-100">
                    <div className="col-md-6">
                      <h6 className="m-0">
                        <b>Change Dealer’s Status</b>
                      </h6>
                      <p className="m-0 create_user_formlabel">
                        Control user access: Delete or suspend user
                      </p>
                    </div>
                    <div className="col-md-6  p-0 ">
                      <FormGroup>
                        <div className="create_user_name">
                          <div className="user_status-btn d-flex justify-content-end">
                            <Button
                              className="status-delete-btn"
                              color="primary"
                              onClick={() => {
                                setDeleteid('delete');
                                setDialogText('remove it');
                                setDeletePopup(true);
                              }}
                            >
                              Delete Dealer
                            </Button>
                          </div>
                          {editData?.status ? (
                            <div className="user_status-btn d-flex justify-content-end">
                              <Button
                                className="status-suspend-btn"
                                color="primary"
                                onClick={() => {
                                  setDeleteid('suspend');
                                  setDialogText('suspend user');
                                  setDeletePopup(true);
                                }}
                              >
                                Suspend Dealer
                              </Button>
                            </div>
                          ) : (
                            <div className="user_status-btn d-flex justify-content-end">
                              <Button
                                className="status-active-btn"
                                color="primary"
                                onClick={() => {
                                  setDeleteid('activate');
                                  setDialogText('activate user');
                                  setDeletePopup(true);
                                }}
                              >
                                ACTIVATE
                              </Button>
                            </div>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                  <hr />
                  {/* </>
                  )} */}
                </>
              ) : (
                <></>
              )}
              {paramid ? (
                <>
                  {canupdatedealer && (
                    <div className="edit-btn d-flex justify-content-end">
                      <Button color="primary" type="submit">
                        Update
                      </Button>
                    </div>
                  )}
                </>
              ) : (
                <div className="submit-btn d-flex justify-content-end">
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              )}
            </form>
          </div>
        </>
      )}
    </>
  );
};

export default CreateRole;
